import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState: any = null;

export const openChatWootSlice = createSlice({
 name: 'openChatWoot',
 initialState,
 reducers: {
  openChatWoot: (state, action: PayloadAction<any>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { openChatWoot } = openChatWootSlice.actions;

export default openChatWootSlice.reducer;
